import React, { useEffect, useState } from "react";
import api, { formatDate } from "../lib/api";

const ACTION_LABELS = {
  login: "Giriş",
  login_failed: "Başarısız Giriş",
  password_changed: "Şifre Değiştirildi",
  password_reset: "Şifre Sıfırlandı",
  user_created: "Kullanıcı Oluşturuldu",
  user_updated: "Kullanıcı Güncellendi",
  sessions_revoked: "Oturumlar Kapatıldı",
  settings_updated: "Ayarlar Güncellendi",
};

const ROLE_LABELS = {
  owner: "İşletme Sahibi",
  manager: "Yönetici",
  cashier: "Kasiyer",
};

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit", { params: { limit: 300 } }).then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="audit-root">
      <div className="mb-6">
        <div className="font-mono-code text-[10px] tracking-[0.3em] text-stone-500">DENETİM</div>
        <h1 className="font-serif-display text-3xl sm:text-4xl text-stone-900">İşlem Kayıtları</h1>
        <p className="text-sm text-stone-500 mt-1">Sisteme yapılan kritik işlemler burada listelenir.</p>
      </div>
      <div className="card-lux overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-stone-50 border-b border-stone-200">
            <tr className="text-xs uppercase tracking-wider text-stone-500">
              <th className="px-4 py-3 text-left">Tarih & Saat</th>
              <th className="px-4 py-3 text-left">Kullanıcı</th>
              <th className="px-4 py-3 text-left">Rol</th>
              <th className="px-4 py-3 text-left">İşlem</th>
              <th className="px-4 py-3 text-left">Detay</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-stone-100">
            {loading && (
              <tr><td colSpan={5} className="text-center py-10 text-stone-400">Yükleniyor…</td></tr>
            )}
            {!loading && items.length === 0 && (
              <tr><td colSpan={5} className="text-center py-14 text-stone-500">Kayıt yok.</td></tr>
            )}
            {items.map((a) => (
              <tr key={a.id}>
                <td className="px-4 py-2 text-xs font-mono-code text-stone-600">{formatDate(a.created_at)}</td>
                <td className="px-4 py-2 text-sm text-stone-900">{a.username || "-"}</td>
                <td className="px-4 py-2 text-xs text-stone-600">{ROLE_LABELS[a.role] || a.role || "-"}</td>
                <td className="px-4 py-2 text-sm text-stone-800">{ACTION_LABELS[a.action] || a.action}</td>
                <td className="px-4 py-2 text-xs text-stone-500 font-mono-code truncate max-w-xs">
                  {a.extra && Object.keys(a.extra).length > 0 ? JSON.stringify(a.extra) : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
